<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="15"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
						</m-search-item>
						<m-search-item label="创建时间">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_repair_list_repair')" prepend-icon="tf-repair" color="main" @click="addRepair">维修</c-button>
                    <c-button v-if="auth('b_repair_list_send_repair')" prepend-icon="tf-send-repair" color="main" @click="batchSendRepair">送修</c-button>
                    <c-button v-if="auth('b_repair_list_send_repair_finish')" prepend-icon="tf-accept" @click="batchCompleteDelivery()">送修完成</c-button>
                    <c-button v-if="hasHandover && auth('b_repair_list_transfer')" prepend-icon="tf-transfer" @click="openTransfer()">批量调拨</c-button>
                    <c-button v-if="hasHandover && auth('b_repair_list_return')" prepend-icon="tf-return-stock" @click="batchReturnToStock()">批量返库</c-button>
                    <c-button v-if="hasHandover && auth('b_repair_handover_confirm_reject')" prepend-icon="tf-batch" @click="confirmReject()">批量同意驳回</c-button>
					<c-button v-if="auth('b_repair_list_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="hasHandover && auth('b_repair_list_transfer')" prepend-icon="tf-transfer" @click="openTransfer(data)">批量调拨</c-button>
					<c-button v-if="hasHandover && auth('b_repair_list_return')" prepend-icon="tf-return-stock" @click="batchReturnToStock(data)">批量返库</c-button>
                    <c-button v-if="hasHandover && auth('b_repair_handover_confirm_reject')" prepend-icon="tf-batch" @click="confirmReject(data)">批量同意驳回</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_repair_list_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

                <template #produce_info="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

                <template #purchase_price="{data}">
                    {{formatPrice(data.purchase_price)}}
                </template>

                <template #repair_cost="{data}">
                    {{formatPrice(data.repair_cost)}}
                </template>

                <template #in_stock_days="{data}">
                    {{formatDay(data.in_stock_days)}}
                </template>
                <template #in_transit_days="{data}">
                    <span :style="{color: data.in_transit_days > 2 ? '#e53e3e' : ''}">{{formatDay(data.in_transit_days)}}</span>
                </template>

                <template #product_state="{data}">
                    <span v-if="sourceHandoverStateText(data)" :style="{color: isSourceRejectPending(data) ? '#e53e3e' : ''}">{{sourceHandoverStateText(data)}}</span>
					<c-state v-else dict="productStateDic" :value="data.product_state"></c-state>
				</template>

                <template #repair_state="{data}">
                    <c-state async dict="repairStateDic" :value="data.repair_state"></c-state>
                </template>

                <template #handover_state="{data}">
                    <c-state dict="ACCEPT_REJECT_STATE" :value="data.handover_state_show"></c-state>
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="180"
					button-limit="6"
				>
					<template #default="{data}">
						<!-- 行级按钮可见性统一由服务端 buttons 下发（版本能力+接驳状态+归属），端内只保留 auth 权限点位 -->
						<c-table-button v-if="auth('b_repair_list_repair') && data.buttons?.repair_record?.visible" icon="tf-detail" @click="openRepairRecordDialog(data)">维修记录</c-table-button>
						<c-table-button v-if="auth('b_repair_list_transfer') && data.buttons?.transfer?.visible" icon="tf-transfer" @click="openTransfer([data])">调拨</c-table-button>
						<c-table-button v-if="auth('b_repair_list_return') && data.buttons?.return_to_stock?.visible" icon="tf-return-stock" @click="batchReturnToStock([data])">返库</c-table-button>
                        <c-table-button v-if="auth('b_repair_handover_confirm_reject') && data.buttons?.confirm_reject?.visible" icon="tf-accept" @click="confirmReject(data)">同意驳回</c-table-button>
						<c-table-button v-if="auth('b_repair_list_send_repair_finish') && data.buttons?.complete_delivery?.visible" icon="tf-finish" @click="quickCompleteDelivery(data)">送修完成</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--调拨弹窗（维修中直调：目标仅质检/销售）-->
			<code-transfer ref="codeTransfer" :allow-states="[22]" :exclude-types="[2]" dialog-title="维修调拨" @resolve="$refs.view.update()"></code-transfer>
		</module>
	</page>
</template>

<script>
    import handoverReject from '@/mixins/handover_reject';
	import {mapState, mapGetters} from 'vuex'
	import codeTransfer from "@/pages/storage/code_transfer.vue";

	export default {
        mixins: [handoverReject],
        handoverModuleType: 2,
		components: {codeTransfer},

		computed: {
			...mapState(['productStateDic', 'repairStateDic', 'handoverStateDic']),
			//版本能力开关（登录时由服务端下发）：门店版无接驳与调拨，页内调拨/返库入口整体不露
			...mapGetters(['hasHandover'])
		},

		methods: {

			/*********发起调拨（维修中→质检/销售，支持扫码补充）**********/
			openTransfer(data) {
                if (!data  || !data.length) {
                    this.$message({message: '请选择要调拨的记录', type: 'warning'});
                    return;
                }
				var list = [];
				if (data) {
					list = Array.isArray(data) ? data : [data];
				} else {
					list = this.$refs.view.$refs.list.getData('selected');
				}
				this.$refs.codeTransfer.open(list);
			},
			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********格式化天数**********/
			formatDay(day) {
				if (day === null || day === undefined || day === '') return '-';
				return parseInt(day) + '天';
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.color_name) parts.push(data.color_name);
				if (data.memory_name) parts.push(data.memory_name);
				return parts.join(' ') || '-';
			},

			/*********批量维修：有选中则打开该产品维修记录详情，无选中则打开新建维修记录弹框************/
			addRepair() {
                this.globalDialog('repairAddDialog', {}, () => {
                    this.$refs.view.update();
                });
			},

			/*********打开维修记录详情弹框（含维修记录+送修记录）**********/
			openRepairRecordDialog(productData) {
				this.globalDialog('repairRecordDialog', {data: productData}, () => {
					this.$refs.view.update();
				});
			},

			/*******送修，支持批量**********/
			batchSendRepair() {
				this.globalDialog('repairDeliveryDialog', {}, () => {
					this.$refs.view.update();
				});
			},

			/*******头部送修完成：扫码模式，无需预选行**********/
			batchCompleteDelivery(data) {
				if (data && data.length) {
					// 行级/批量调用：取第一条有delivery_id的记录
					var row = data.find(item => item.delivery_id);
					if (!row) {
						this.$message({message: '选中记录中没有可送修完成的项', type: 'warning'});
						return;
					}
					this.quickCompleteDelivery(row);
				} else {
					// 头部按钮：打开扫码模式
					this.globalDialog('repairCompleteDialog', {}, () => {
						this.$refs.view.update();
					});
				}
			},

			/*******快速送修完成：直接从列表行发起，无需进入维修记录弹框**********/
			quickCompleteDelivery(data) {
				var deliveryData = {
					id: data.delivery_id,
					produce_unique_code: data.produce_unique_code,
					produce_imei: data.produce_imei,
					repair_unit: data.repair_unit,
					brand_name: data.brand_name,
					model_name: data.model_name,
					color_name: data.color_name,
					memory_name: data.memory_name
				};
				this.globalDialog('repairCompleteDialog', {data: deliveryData}, () => {
					this.$refs.view.update();
				});
			},

			/*********批量返库**********/
			batchReturnToStock(data) {
                if (!data  || !data.length) {
                    this.$message({message: '请选择要返库的记录', type: 'warning'});
                    return;
                }
				var produceUniqueCodeIds = data.map(item => item.produce_unique_code_id).join(',');
				this.$confirm({
					message: data.length === 1 ? '确认将该记录返库吗？' : '确认将选中的' + data.length + '条记录返库吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/repair/return',
							data: {product_code_ids: produceUniqueCodeIds},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
